import { IsMobile } from '@one/utils/is-mobile.utils';

export function IsDeviceWeak(): boolean {
  if (typeof window === 'undefined') return false;

  const ram = (navigator as any).deviceMemory || 0;

  return ram <= 4 && !IsMobile;
}
